<script setup lang="ts">
const {
  licenseText,
  primarySeal,
  primarySealIsTypeCuracao,
  primarySealIsTypeBase,
  primarySealIsTypeImage,
  customSealsOnLicenseText,
} = useLicenses();

const hasCustomSeals = computed(() => {
  return (
    customSealsOnLicenseText.value && customSealsOnLicenseText.value?.length
  );
});

const showFooterSection = computed(() => {
  return (
    licenseText.value ||
    primarySealIsTypeCuracao.value ||
    primarySealIsTypeBase.value ||
    primarySealIsTypeImage.value ||
    hasCustomSeals.value
  );
});
</script>

<template>
  <div
    v-if="showFooterSection"
    class="footer-section"
  >
    <div
      v-if="licenseText"
      class="register-section"
    >
      <p v-html="licenseText" />
    </div>

    <div
      v-if="primarySeal"
      class="cactus-license__seals"
    >
      <FooterItemsSealsCuracaoGaming
        v-if="primarySealIsTypeCuracao"
        class="curacao"
        :src="primarySeal?.src"
      />

      <FooterItemsSeals
        v-if="primarySealIsTypeBase"
        :id="primarySeal?.id"
        :size="primarySeal?.size"
        :type="primarySeal?.type"
      />

      <FooterItemsSeals
        v-if="primarySealIsTypeImage"
        :id="primarySeal?.id"
        :href="primarySeal?.href"
        :size="primarySeal?.size"
        :src="primarySeal?.src"
        :type="primarySeal?.type"
      />

      <template v-if="hasCustomSeals">
        <FooterItemsSeals
          v-for="(custom, i) in customSealsOnLicenseText"
          :id="custom?.id || i"
          :key="i"
          :href="custom?.href"
          :size="custom?.size"
          :src="custom?.src"
          :type="custom?.type"
        />
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer-section {
  @apply w-full py-6 px-1 lg:px-2 flex flex-col-reverse justify-center items-center gap-2 sm:flex-row text-center sm:text-left;

  .register-section {
    @apply text-[.66rem] text-footer-texts lg:pr-2;
  }

  .cactus-license__seals {
    @apply flex items-center gap-x-5 gap-y-2 flex-wrap md:flex-nowrap mb-4 justify-center md:justify-end;

    a {
      @apply mx-auto;
    }
  }
}
</style>
